export const auctions = (state) => Object.values(state.list || {});
export const auctionsBatchesHistory = (state) => Object.values(state.listHistory || {});
export const selectedAuction = (state) => (state.selectedAuction);
export const selectedAuctionBatches = (state) => (state.selectedAuctionBatches);
export const pagination = (state) => (state.pagination);
export const loading = (state) => state.loading;
